import React from 'react';
import { motion } from 'framer-motion';
import Icon from './Icon';
import { OrnDivider } from './Ornaments';
import { TRUST, LOGO_URL } from '../../lib/constants';

const TrustFooter = () => (
  <footer data-testid="trust-footer" className="bg-ink text-ivory">
    {/* Trust bar */}
    <div className="border-b border-gold/15 py-14">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-5 md:grid-cols-4 md:px-8">
        {TRUST.map((t, i) => (
          <motion.div
            key={t.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="flex flex-col items-center gap-3 text-center"
            data-testid={`trust-${i}`}
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 text-gold">
              <Icon name={t.icon} className="h-5 w-5" strokeWidth={1.6} />
            </div>
            <p className="font-sans text-sm leading-tight text-ivory/85">
              {t.title}
              <br />
              <span className="text-ivory/60">{t.sub}</span>
            </p>
          </motion.div>
        ))}
      </div>
    </div>

    {/* Bottom brand */}
    <div className="mx-auto max-w-7xl px-5 py-12 md:px-8">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="rounded-2xl bg-white p-3 shadow-[0_18px_40px_-24px_rgba(212,175,55,0.5)]">
          <img src={LOGO_URL} alt="Omvedha — Sacred Rituals. Trusted Guidance." className="h-20 w-auto" />
        </div>
        <OrnDivider tone="#D4AF37" />
        <p className="font-serif text-sm uppercase tracking-[0.25em] text-ivory/60">
          Rooted In Tradition; Delivered With Trust
        </p>
        <a
          href="https://www.omvedha.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-website-link"
          className="font-sans text-sm text-gold transition-colors hover:text-gold/70"
        >
          www.omvedha.com
        </a>
        <p className="mt-2 font-sans text-xs text-ivory/40">
          © {new Date().getFullYear()} Omvedha. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default TrustFooter;
